const enJSON = {
  AUTH_SIGN_UP_CARD_TITLE: 'Sign Up',
  AUTH_SIGN_UP_CARD_SUB_TITLE:
    'Fill in the fields below to sign up for an account.',
  AUTH_SIGN_UP_CARD_GOOGLE_BUTTON: 'Sign Up with Google',
  AUTH_SIGN_UP_CARD_OR_SEPARATOR: 'or',
  AUTH_SIGN_UP_CARD_NAME_FIELD_LABEL: 'Name',
  AUTH_SIGN_UP_CARD_NAME_FIELD_ERROR: 'The name field is required',
  AUTH_SIGN_UP_CARD_EMAIL_FIELD_LABEL: 'Email',
  AUTH_SIGN_UP_CARD_ACCELERATOR_FIELD_LABEL: 'Accelerator Type',
  AUTH_SIGN_UP_CARD_EMAIL_FIELD_ERROR_REQUIRED: 'The email field is required',
  AUTH_SIGN_UP_CARD_EMAIL_FIELD_ERROR_INVALID:
    'The email provided should be a valid email address',
  AUTH_SIGN_UP_CARD_PASS_FIELD_LABEL: 'Password',
  AUTH_SIGN_UP_CARD_PASS_FIELD_ERROR: 'The password field is required',
  AUTH_SIGN_UP_CARD_TERMS_AGREE_STATEMENT: 'I accept the',
  AUTH_SIGN_UP_CARD_TERMS_AND_CONDITIONS: 'terms and conditions',
  AUTH_SIGN_UP_CARD_TERMS_AND_CONDITIONS_ERROR:
    'You must agree to our terms and conditions',
  AUTH_SIGN_UP_CARD_BUTTON: 'Sign Up',
  AUTH_SIGN_UP_CARD_HAVE_ACCOUNT: 'Already have an account?',
  AUTH_SIGN_UP_CARD_LOGIN_LINK: 'Sign in here',
  AUTH_SIGN_UP_SIDEBAR_TITLE: 'Create digital inspection reports',
  AUTH_SIGN_UP_SIDEBAR_USE_CASE_1: 'Inspection management dashboard',
  AUTH_SIGN_UP_SIDEBAR_USE_CASE_2: 'Easy to use inspection app',
  AUTH_SIGN_UP_SIDEBAR_USE_CASE_3: 'Mobile-first digital inspection reports',
  AUTH_SIGN_UP_SIDEBAR_USE_CASE_4: 'Try for free for 30 days',
  AUTH_LOGIN_CARD_EMAIL_FIELD_LABEL: 'Email',
  AUTH_LOGIN_CARD_EMAIL_FIELD_ERROR_REQUIRED: 'The email field is required',
  AUTH_LOGIN_CARD_EMAIL_FIELD_ERROR_INVALID:
    'The email provided should be a valid email address',
  AUTH_LOGIN_CARD_PASS_FIELD_LABEL: 'Password',
  AUTH_LOGIN_CARD_PASS_FIELD_ERROR: 'The password field is required',
  AUTH_LOGIN_CARD_GOOGLE_BUTTON: 'Sign in with Google',
  AUTH_LOGIN_CARD_BUTTON: 'Sign in',
  AUTH_LOGIN_CARD_FORGOT_PASSWORD: 'Forgot Password?',
  AUTH_LOGIN_CARD_RESET_PASSWORD_LINK: 'Reset Password',
  AUTH_LOGIN_CARD_NO_ACCOUNT: "Don't have an account?",
  AUTH_LOGIN_CARD_REGISTER_LINK: 'Register',
  AUTH_LOGIN_CARD_ERROR_INVALID_CREDENTIALS: 'Incorrect email or password',
  USERS_LIST_PAGE_HEADER_TITLE: 'Users',
  USERS_LIST_PAGE_HEADER_CAPTION: 'Manage your Users',
  USERS_LIST_EMPTY_MESSAGE: 'No Users',
  USERS_LIST_PAGE_HEADER_CREATE_BUTTON: 'Create New User',
  USERS_LIST_DELETE_USER_CONFIRMATION_MESSAGE:
    'Do you really want to delete this User?',
  USERS_LIST_DELETE_USER_BUTTON_TOOLTIP: 'Delete',
  USERS_LIST_CREATE_USER_PASSWORD_DIALOG_TITLE: 'User Password',
  USERS_LIST_CREATE_USER_PASSWORD_DIALOG_CAPTION: 'Use this password to login',
  USERS_LIST_CREATE_USER_DIALOG_TITLE: 'Create New User',
  USERS_LIST_CREATE_USER_DIALOG_CAPTION: 'Add a new user',
  USERS_LIST_CREATE_USER_DIALOG_CREATE_BUTTON: 'Create User',
  REPORT_DETAILS_HEADER_TITLE: 'Report Details',
  REPORT_DETAILS_HEADER_DOWNLOAD_PDF_BUTTON: 'Download PDF',
  REPORT_DETAILS_HEADER_DOWNLOAD_XLSX_BUTTON: 'Download XLSX',
  REPORT_DETAILS_NO_ANSWER: 'No Answer',
  REPORT_VERIFICATION_ACCOUNTABILITY_TITLE: 'Accountability',
  REPORT_VERIFICATION_ACCOUNTABILITY_SUBTITLE:
    'This section shows who performed the report',
  REPORT_VERIFICATION_VERIFICATION_TITLE: 'Verification',
  REPORT_VERIFICATION_VERIFICATION_SUBTITLE: ' All data verified by checkfirst',
  REPORT_HEADER_UNIT_ID_PREFIX: ' Unit',
  REPORT_HEADER_INSPECTION_ID_PREFIX: ' Inspection',
  EDIT_UNIT_DELETE_CATEGORY_CONFIRMATION_TITLE: 'Are you sure?',
  EDIT_UNIT_DELETE_CATEGORY_CONFIRMATION_SUBTITLE:
    'This will also delete any items in this category.',
  COPIED: 'Copied successfully ...',
  COMMENT: 'COMMENT',
  configurations: 'configurations',
  new_configuration: 'new configuration',
  Key: 'Key',
  Title: 'Title',
  Actions: 'Actions',
  Clients: 'Clients',
  Value: 'Value',
  Edit: 'Edit',
  Cancel: 'Cancel',
  Save: 'Save',
  Saved: 'Saved',
  OPTIONS: 'Options',
  FORGET_PASSWORD: 'Forget Pssword',
  UPDATE_PASSWORD_TITLE: 'Update Password',
  CONFIRM_PASSWORD_VALIDATION:
    'Please enter the same password in the fields for Password and Confirm Password',
  PASSWORD_VALIDATION: 'The password field is required',
  PASSWORD_UPDATED: 'Password was updated successfully, Please try to login',
  ERROR: 'Something went wrong',
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  UPDATE_PASSWORD: 'Update Password',
  UPDATE_USER: 'Update User',
  INVALID_EMAIL: 'Invalid Email',
  UPDATE_PASSWORD_TOGGEL: 'Update Password',
  NAME_VALIDATION: 'The name field is required',
  EMAIL_VALIDATION: 'The email field is required',
  MESSAGE_VALIDATION: 'the message field is required',
  SHOULD_VALID_EMAIL: 'The email provided should be a valid email address',
  IMAGE_VALIDATION: 'The image field is required',
  NAME_PLACEHOLDER: 'Name...',
  NAME_LABEL: 'Name',
  EMAIL_PLACEHOLDER: 'Email...',
  EMAIL_LABEL: 'Email',
  MESSAGE_LABEL: 'Message',
  CLIENT_IMAGE_LABEL: 'Image',
  PASSWORD_PLACEHOLDER: 'Password...',
  PASSWORD_LABEL: 'Password',
  CONFIRM_PASSWORD_PLACEHOLDER: 'Confirm Password...',
  CONFIRM_PASSWORD_LABEL: 'Confirm Password',
  SAVE_USER: 'Save User',
  UPDATE_PROFILE: 'Update Profile',
  FLAGGED: 'Flagged',
  REPORT_DETAILS: 'Report Details',
  REMOVE_FLAG: 'Remove Flag',
  ADD_FLAG: 'Add Flag',
  CLIENT_REPORTS: 'Client reports',
  CLIENTS: 'Clients',
  REPORTS: 'Reports',
  UNITS: 'Units',
  DELETE: 'Delete',
  DELETED: 'Deleted Successfully',
  UNIT_DELETE_ALERT_TITLE: 'Are you sure you want to delete this unit?',
  NO: 'No',
  YES: 'Yes',
  FORGET_PASSWORD_Q: 'Forget password?',
  RESET_PASSWORD: 'Reset Password',
  RESET_PASSWORD_TITLE: 'Recover Password',
  RESET_PASSWORD_SUB_TITLE: 'Enter your email to reset your password',
  UPDATE_PASSWORD_SUB_TITLE: 'Enter your password to update your password',
  SEND_NEW_PASSWORD: 'Send me a new password',
  TRY_SIGN: 'Want to try to sign in again?',
  CLICK_HERE: 'Click here',
  RESET_PASSWORD_INSTRUCTIONS:
    'The password reset instructions have been sent to your email',
  CHECK_EMAIL_INSTRUCTIONS: 'Check your email for further instructions',
  CONTINUE_LOGIN: 'Continue to login',
  TITLE: 'Title',
  REFERENCES: 'Inspections',
  REFERENCE: 'Inspection',
  GENERATE_REFERENCE: 'Create new Inspection',
  LINK: 'Link',
  NO_REPORTS: 'No reports created yet',
  FREE_TRIAL: 'Start your free trial today',
  EMAIL_VERIFICATION: 'Verify your email',
  SEND_EMAIL_TO: 'We have sent an email to',
  EMAIL_VERIFICATION_CONTINUE:
    'To continue, please check your email and click on the link to verify your account.',
  NOT_RECEIVE_EMAIL: "Didn't receive the email?",
  RESEND_EMAIL: 'Re-send the Email',
  EMAIL_VERIFICATION_RESEND_ERROR: 'Failed to send the email',
  TERMS_VALIDATION: 'You must agree to our terms and conditions',
  REGISTRATION_LAST_STEP: 'One more step and you’re done!',
  KNOW_MORE_INFO: 'Please let us know your company name',
  COMPANY_VALIDATION: 'The company field is required',
  COMPANY_LABEL: 'Company name',
  SIGN_UP_HERE: 'Sign up',
  GETTING_START: 'Get Started',
  THANK_YOU: 'Thank You!',
  ON_BOARD: 'We are excited to get you on board.',
  UPDATE: 'Update',
  SAVED: 'Saved Successfully',
  SENT: 'Sent Successfully',
  UPDATE_COMPANY_HEADER: 'Company Details',
  UPDATE_COMPANY_INFO: 'You should set company name to continue',
  SEND_INSTRUCTIONS_EMAIL: 'Send instructions email',
  TOKEN_INSTRUCTION_EMAIL_TITLE: 'Send report instructions email',
  INSTRUCTION_EMAIL: 'Send Instructions',
  RESET_PASSWORD_SUCCESS:
    'Thanks, if the email address you entered is correct, you will be receiving an email shortly with instructions on how to reset your password',
  UPDATE_CLIENT: 'Update Client',
  UPDATE_CLIENT_PAGE_TITLE:
    "Use this page to update your organization's details.",
  UPDATE_CLIENT_CARD_TITLE: 'Organization Details',
  COMPANY_NAME_PLACEHOLDER: 'Update company name',
  COMPANY_NAME_LABEL: 'Company name',
  SAVE_CLIENT: 'Save Client',
  'Yes/No': 'Yes/No',
  MEDIA: 'Media',
  TEXT: 'Text',
  NUMBER: 'Number',
  RADIO_BUTTON: 'Multiple choice',
  CHECK_BOX: 'Checkboxes',
  SELECT_OPTIONS_HOLDER: 'separate entries with return key',
  SELECT_OPTIONS: 'Options',
  SELECT_OPTIONS_HELPER:
    'Please list the options in the text field; use Enter to separate between options',
  REGISTER_HTML_TITLE: 'Checkfirst - Sign up',
  FILTER: 'Filter',
  FLAGGED_all: 'Show all',
  FLAGGED_true: 'Flagged reports only',
  MANAGE_API_KEY_SUBHEADER: 'MANAGE YOUR API KEYS',
  API_KEY_MODAL_HEADER: 'Generate API Key',
  API_KEY_MODAL_SUBHEADER: 'Please enter a name to identify this key',
  CREATED_API_KEY_MODAL_HEADER: 'Key created',
  CREATED_API_KEY_MODAL_SUBHEADER:
    "Please store it in a safe place as it can't be recovered. Check the Developer Documentation to learn how to use it!",
  NAME: 'Name',
  DOWNLOAD_XLSX: 'Download Xlsx',
  SUBSCRIBE_TITLE: 'Choose your plan',
  SUBSCRIBE_BODY:
    'Simple, transparent pricing that grows with you. Try any plan free for 30 days.',
  SUBSCRIBE_BODY2: 'Annual pricing (save 15%)',
  SUBSCRIBE: 'Subscribe',
  PAYMENT_SUCCESS_BUTTON: 'Get started',
  TRY_AGAIN: 'Try Again',
  PAYMENT_SUCCESS_TITLE: 'Thank you',
  PAYMENT_SUCCESS_BODY:
    'Your information was saved successfully. We are excited to get you on board!',
  PAYMENT_FAILURE_TITLE: 'Something went wrong',
  PAYMENT_FAILURE_BODY:
    'Your payment may be failed because of your card balance or something else please contact customer service for more clarification',
  SUBSCRIPTION_TITLE: 'Manage subscriptions',
  SUBSCRIPTION_DESCRIPTION: 'Manage your subscription',
  SUBSCRIPTION_CARD_HEADER: 'Subscription information',
  SUBSCRIPTION_CARD_SUB_HEADER:
    'Manage details related to your associated email addresses',
  SUBSCRIPTION_PLAN: 'Plan',
  SUBSCRIPTION_CARD: 'Credit Card',
  SUBSCRIPTION_BILLED_WITH: 'Billed with Mastercard •••• ',
  MANAGE_SUBSCRIPTION: 'Manage subscription',
  SUBSCRIPTION_ACTIVE: 'Active',
  SUBSCRIPTION_IN_ACTIVE: 'InActive',
  SUBSCRIPTION_END: 'END DATE',
  PRICING_PLANS: 'Pricing plans',
  CURRENCY: '€',
  MONTH: 'mth',
  YEAR: 'yr',
  ENTERPRISE_TITLE: 'Get in touch',
  ENTERPRISE_NAME: 'Platinum',
  ENTERPRISE_DESCRIPTION: 'Created for enterprise customers',
  ENTERPRISE_FEATURE1: 'Unlimited units',
  ENTERPRISE_FEATURE2: 'Single sign-on',
  ENTERPRISE_FEATURE3: 'High availability SLA',
  ENTERPRISE_FEATURE4: 'Bespoke integrations',
  ENTERPRISE_FEATURE5: 'Onboarding support & training',
  ENTERPRISE_FEATURE6: 'All Gold features',
  EDIT_ITEM: 'Update',
  UPDATE_CHECKLIST_ITEM: 'Update checklist items',
  EDIT: 'Edit',
  N0_CLIENTS_ACTIVITIES: 'No Clients Activities',
  CREATION_DATE: 'Creation Date',
  ACTIVITY_ACTION: 'Action',
  ACTIVITY_MODULE: 'Module',
  CLIENT_NAME: 'Name',
  CLIENT_LABEL: 'Client',
  CLIENT_ACTIVITY_SEARCH_PLACEHOLDER: 'Select Client',
  CLIENT_ACTIVITY_TITLE: 'Clients Activities',
  MULTI_MEDIA: 'Multimedia',
  CONDITION: 'Condition',
  UPLOAD: 'Select an image to upload',
  BRONZE: 'Bronze',
  GOLD: 'Gold',
  ENTERPRISE: 'Enterprise',
  NONE: 'None',
  HISTORY: 'History',
  CHECKLIST_ITEM_DRILL_DOWN_DESCRIPTION:
    'Below is the history of all inspections for this unit. Click on each date to load the corresponding report.',
  REPORTS_TO_DATE: 'Reports to date',
  FLAGGED_REPORTS: 'Flagged Reports',
  ACTIVE_UNITS: 'Active Units',
  RECENT_REPORTS: 'Recent Reports',
  RECENT_UNITS: 'Recently added units',
  INSPECTOR: 'Inspector',
  DATE: 'Date',
  REPORTS_COUNT: 'Reports',
  UNIT: 'Unit',
  VIEW_ALL: 'View all',
  ISSUE_PRIORITY: 'Issue Priority',
  ISSUE_TITLE: 'Issue Priority',
  ISSUE_DESCRIPTION: 'Description',
  ISSUE_ID: 'ID',
  ISSUE_REPORTED: 'Reported',
  ISSUES: 'Issues',
  ISSUE_GALLERY: 'Gallery',
  ISSUE_DETAILS: 'Issue Details',
  SHARING_REPORT: 'Share',
  LOGGED_IN_FIRST: 'You must be logged in',
  WELCOME_MESSAGE: 'Welcome, ',
  YOUR_STATISTICS_MESSAGE: 'Your statistics for today, ',
  ISSUES_HEADER: 'Issues',
  ISSUES_SUBHEADER: 'Manage issues found during inspection',
  ISSUES_PRIORITY: 'PRIORITY',
  UPPERCASE_TITLE: 'TITLE',
  STATUS: 'STATUS',
  UPPERCASE_UNIT: 'UNIT',
  DESCRIPTION: 'DESCRIPTION',
  IMAGES: 'IMAGES',
  REPORTED: 'REPORTED',
  DEACTIVATED: 'Deactivated',
  DEACTIVATE: 'Deactivate',
  SIGN: 'Sign',
  SIGN_MODAL_TITLE: 'Sign Report',
  SIGN_MODAL_DESCRIPTION:
    'Use this dialog window to sign the inspection report.',
  NAME_HOLDER: 'Your Name',
  NAME_REQUIRED: 'The name field is required',
  SIGNATURE_IMAGE_URL: 'Draw your Signature',
  SIGNATURE_REQUIRED: 'The signature field is required',
  SIGN_BUTTON: 'Sign',
  UPDATE_PASSWORD_INFO: 'Do you want update you password?',
  UPDATE_PASSWORD_LINK: 'Update password',
  UPDATE_USER_PASSWORD: 'Change Password',
  UPDATE_USER_PASSWORD_CARD_TITLE: 'User Information',
  OLD_PASSWORD_LABEL: 'Current Password',
  SAVE_USER_PASSWORD: 'Save',
  OLD_PASSWORD_PLACEHOLDER: 'Current Password...',
  COPY_REPORT_TOKEN: 'Copy report token',
  QR_CODE: 'Generate QR Image',
  QR_CODE_MODAL_TITLE: 'Inspection Link QR',
  DOWNLOAD: 'Download',
  DOWNLOADED: 'Downloaded Successfully',
  DEVELOPMENT: 'Development',
  UNIT_FORM_DESCRIPTION_PLACEHOLDER: 'Enter a description here.',
  UNIT_FORM_TITLE_PLACEHOLDER: 'Enter a title here.',
  UNIT_FORM_DESCRIPTION_CAPTION:
    'This information will be seen by the end user when they start the report, so make sure that this description helps them create the report in the way that is best for your business.',
  CREATE_USER_NAME_PLACEHOLDER: 'Enter the name here',
  CREATE_USER_EMAIL_PLACEHOLDER: 'Enter the email here',
  SAVE: 'Save',
  UPLOAD_CLIENT_LOGO: 'Organization logo',
  COPY: 'Copy',
  ROLE: 'Role',
  ROLE_LABEL: 'Select user Role',
  ROLE_client: 'Client Admin',
  ROLE_client_manager: 'Client Manager',
  ROLE_client_contributor: 'Client Contributor',
  USERS_LIST_EDIT_USER_BUTTON_TOOLTIP: 'Update User',
  USERS_LIST_UPDATE_USER_DIALOG_TITLE: 'Update User Information',
  USERS_LIST_UPDATE_USER_DIALOG_CAPTION: 'Update User',
  USERS_LIST_UPDATE_USER_DIALOG_CREATE_BUTTON: 'Update user',
  WEBHOOK_SCREEN_LIST_TITLE: 'Webhooks',
  WEBHOOK_SCREEN_LIST_CAPTION: 'Manage your webhooks here',
  WEBHOOK_SCREEN_LIST_CREATE_BUTTON: 'Add webhook',
  REPORT_CREATED: "Report",
  ISSUE_CREATED: "Issue",
  COUNTER_SIGNATURE_CREATED: "Counter signature",
  TYPE: 'TYPE',
  URL: "URL",
  MODIFIED: "MODIFIED",
  NO_WEBHOOKS_ADDED: "No webhooks added yet.",
  ACTION: 'ACTION',
  EDIT_WEBHOOK: 'Edit',
  WEBHOOK_DETAILS: 'Details',
  WEBHOOK_SCREEN_SAVE_TITLE: 'Add Webhook',
  WEBHOOK_SCREEN_SAVE_CAPTION: 'Select which type of event you would like to be notified about and then add the URL for your webhook.',
  HOOK_TYPE_REQUIRED: 'Type field is required',
  HOOK_URL_REQUIRED: 'URL field is required',
  ADD_WEBHOOK: 'Add Webhook',
  WEBHOOK_TYPE_LABEL: 'Type',
  WEBHOOK_TYPE_PLACEHOLDER: 'Type',
  WEBHOOK_URL_PLACEHOLDER: 'URL',
  WEBHOOK_URL_LABEL: 'URL',
  WEBHOOK_SCREEN_DETAILS_TITLE: 'Webhooks',
  WEBHOOK_SCREEN_DETAILS_CAPTION: 'Organisation / Webhooks',
  HOOK_DATE: 'DATE',
  WEBHOOK_RETRY: "Retry",
  SUCCESS: "Success",
  FAILED: "Failed",
  REQUEST_DETAIL_MODAL_HEADER: "Request details",
  DETAILS: "DETAILS",
  RESPONSE: "RESPONSE",
  BODY: "Body",
  ACTIONS: "Actions",
  INVALID_MAGIC_LINK: "The magic link maybe invalid or expired"
};

export default enJSON;
